import VueI18n from "vue-i18n";

import {
  UserActivationActionFlow,
  UserActivationActionMessage,
  UserActivationActionTypeEnum
} from "./types";

export function getMessageActionTemplate(i18n: VueI18n): UserActivationActionMessage {
  return {
    type: UserActivationActionTypeEnum.Message,
    variants: [ {
      text: i18n.t('auto_reply_actions_new_action_text').toString().trim(),
      attachments: [],
      buttons: [],
      disable_link_preview: false,
      disable_notify: false,
      pin: false,
      protect_content: false,
      remove_after: 0,
      remove_previous: false,
      send_after: 0,
    } ]
  }
}

export function getFlowActionTemplate(flowId?: string): UserActivationActionFlow {
  return {
    type: UserActivationActionTypeEnum.Flow,
    flow: flowId ?? '',
    output: 0,
  }
}
